import React, { Component } from "react";
import { Container, Row, Col, Media } from "reactstrap";
import { joinCss } from "../helpers/utils";

import classes from "./Instructions.module.scss";

import documentPolygon from "../images/documentPolygon.png";
import fixPolygon from "../images/fixPolygonBig.png";
import editionPolygon from "../images/editionPolygonBig.png";
import quantitiesPolygon from "../images/quantitiesPolygon.png";
import imgCenterRight from "../images/kubionCenterRight.png";
import imgTopLeft from "../images/kubionTopLeft.png";
import imgBottomLeft from "../images/kubionBottomLeft.png";

class instructions extends Component {
  constructor() {
    super();
    this.state = {
      displayImages: true
    };
  }

  updateDimensions() {
    if (window.innerWidth <= 768 || window.screen.width <= 768) {
      this.setState({ displayImages: false });
    } else {
      this.setState({ displayImages: true });
    }
  }

  /**
   * Add event listener
   */
  componentDidMount() {
    this.updateDimensions();
    window.addEventListener("resize", this.updateDimensions.bind(this));
  }

  /**
   * Remove event listener
   */
  componentWillUnmount() {
    window.removeEventListener("resize", this.updateDimensions.bind(this));
  }
  render() {
    const centerRight = this.state.displayImages ? (
      <Media
        object
        className={joinCss(classes.imgCenterRight, classes.kubionImg)}
        src={imgCenterRight}
        alt="קוביות"
      />
    ) : (
      ""
    );
    const topLeft = this.state.displayImages ? (
      <Media
        object
        className={joinCss(classes.imgTopLeft, classes.kubionImg)}
        src={imgTopLeft}
        alt="קוביות"
      />
    ) : (
      ""
    );
    const bottomLeft = this.state.displayImages ? (
      <Media
        object
        className={joinCss(classes.imgBottomLeft, classes.kubionImg)}
        src={imgBottomLeft}
        alt="קוביות"
      />
    ) : (
      ""
    );
    return (
      <div className={classes.instructionsDiv}>
        {centerRight}
        {topLeft}
        {bottomLeft}
        <Container className={joinCss(classes.instructionsContainer)}>
          <Row>
            <Col lg="4" md="12" className="pr-5">
              <div className={classes.instructionsHeader}>
                הוראות והנחיות למשתמשים
              </div>
              <div className={classes.instructionsSubHeader}>
                במפרט הכללי לעבודות בנייה – 1.1.2017
              </div>
            </Col>
            <Col lg="8" md="12">
              <Container>
                <Row className={classes.instructionsRow}>
                  <Col lg="6" md="12">
                    <Media
                      object
                      className={classes.instuctionLogo}
                      src={documentPolygon}
                      alt="מסמכים"
                    />
                    <div className={classes.instuctionSubjectBig}>
                      המפרטים הכלליים לעבודות בנייה
                    </div>
                    <div className={classes.instructionContant}>
                      נועדו להיות חלק ממסמכי המכרז והחוזה לבנייה של משרדי ממשלה
                      והם מבוססים על כך שהתנאים החוזיים יהיו אלה של "החוזה
                      לביצוע מבנה ע"י קבלן" (מדף 3210).
                    </div>
                  </Col>
                  <Col lg="6" md="12">
                    <Media
                      object
                      className={classes.instuctionLogo}
                      src={fixPolygon}
                      alt="דפי תיקון"
                    />
                    <div className={classes.instuctionSubject}>דפי התיקון</div>
                    <div className={classes.instructionContant}>
                      המופיעים בחלק מהמפרטים יהוו חלק מהחוזה עם הקבלן רק אם
                      שולבו במפורש, במפרט המיוחד, כחלק ממסמכי החוזה. מספר דפי
                      התיקון המופיע בתצוגה של כל הפרקים, מתייחס למספרי דפי
                      התיקון במהדורה האחרונה.
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col lg="6" md="12">
                    <Media
                      object
                      className={classes.instuctionLogo}
                      src={editionPolygon}
                      alt="מהדורות"
                    />
                    <div className={classes.instuctionSubject}>
                      התייחסות למהדורות
                    </div>
                    <div className={classes.instructionContant}>
                      באתר מופיע גם לוח פרסומים, בו רשומה מהדורת הפרק, נכון
                      לתאריך לוח הפרסומים. באתר מתפרסמים מספר פרקים שיצאו
                      במהדורות שונות לדוגמא: פרק 00 – מהדורת 2003 ומהדורת 2007
                      ומהדורת דצמבר 2009. כל פרק חדש שיפורסם יתווסף לאתר,
                      במהדורתו החדשה. המהדורה הקובעת לגבי חוזה מסויים היא זאת
                      המאוזכרת במסמכי החוזה.
                    </div>
                  </Col>
                  <Col lg="6" md="12">
                    <Media
                      object
                      className={classes.instuctionLogo}
                      src={quantitiesPolygon}
                      alt="כתבי כמויות"
                    />
                    <div className={classes.instuctionSubjectBig}>
                      תבנית להכנת כתבי כמויות
                    </div>
                    <div className={classes.instructionContant}>
                      למפרטים שפורסמו החל משנת 2006, צורפה תבנית להכנת כתבי
                      כמויות. התבנית מהווה הנחייה להכנת סעיפים לכתבי הכמויות
                      במכרזים/חוזים, המסתמכים על אופני המדידה ותכולת המחירים של
                      הפרקים המתאימים.
                    </div>
                  </Col>
                </Row>
              </Container>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

export default instructions;
